var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Map Pin",
    clipPath: "url(#clip0_118_520)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.364 17.3678L12 23.7318L5.636 17.3678C4.37734 16.1092 3.52019 14.5055 3.17293 12.7597C2.82567 11.0139 3.00391 9.20426 3.6851 7.55973C4.36629 5.9152 5.51984 4.5096 6.99988 3.52067C8.47992 2.53174 10.22 2.00391 12 2.00391C13.78 2.00391 15.5201 2.53174 17.0001 3.52067C18.4802 4.5096 19.6337 5.9152 20.3149 7.55973C20.9961 9.20426 21.1743 11.0139 20.8271 12.7597C20.4798 14.5055 19.6227 16.1092 18.364 17.3678ZM12 13.0038C12.5304 13.0038 13.0391 12.7931 13.4142 12.418C13.7893 12.043 14 11.5343 14 11.0038C14 10.4734 13.7893 9.96469 13.4142 9.58961C13.0391 9.21454 12.5304 9.00383 12 9.00383C11.4696 9.00383 10.9609 9.21454 10.5858 9.58961C10.2107 9.96469 10 10.4734 10 11.0038C10 11.5343 10.2107 12.043 10.5858 12.418C10.9609 12.7931 11.4696 13.0038 12 13.0038Z",
    fill: "#FFA3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/Map Pin.e30298920ab6b838a4e14d266713cf8c.svg";
export { ForwardRef as ReactComponent };